export interface ContactsData{
    // Type annotations let us declare varaiables, properties, and function paramters with specific types.
    // This allows the Typescript compiler to check that the code adheres to these types. In short, type 
    // annotations allow TypeScript to catch bugs where our code is using the wrong type.
    contactId: number;
    name: string;
    email: string;
    message: string;
    created: Date;
}

const contacts: ContactsData[] = [
    {
      contactId: 1,
      name: 'eric hermoso',
      email:'Eric.Hermoso@ocpw.ocgov.com',
      message: 'this is a simple test',
      created: new Date(),
    },
    {
      contactId: 2,
      name: 'eric hermoso',
      email:'Eric.Hermoso@ocpw.ocgov.com',
      message: 'this is a simple test',
      created: new Date(),

    },
    {
      contactId: 3,
      name: 'eric hermoso',
      email:'hermosoeric28@yahoo.com',
      message: 'this is a simple test',
      created: new Date(),
    },
    {
      contactId: 4,
      name: 'eric hermoso',
      email:'erichermoso5@yahoo.com',
      message: 'this is a simple test',
      created: new Date(),
    },
  ];

// The getUnansweredQuestions function above doesn't  simulate a web API call very well becuase it isn't
// asynchronous. Lets change the function to be asynchronous
const wait = (ms: number): Promise<void> =>{
  return new Promise(resolve => setTimeout(resolve,ms));
}

export interface PostContactData{
  name: string;
  email: string;
  message: string;
  created: Date;
}
export const postContact = async(
  contactParam : PostContactData,
  ): Promise<ContactsData | undefined> =>{
    await wait(900);
    const contactId = Math.max(...contacts.map( x => x.contactId)) + 1;
    const newContact: ContactsData = {
      ...contactParam,
      contactId,
    };
    contacts.push(newContact);
    return newContact;
  }
